import { createReducer, on } from '@ngrx/store';
import { OrganizationDetails } from '../../../models/organization-details.model';
import { IDropdown } from '../../../models/dropdown.model';
import { OrganizationAdminActions } from '../../actions/organization-admin/organization-admin.actions';
import { UserAdminActions } from '@store/actions/user-admin/user-admin.actions';

export const organizationAdminFeatureKey = 'organizationAdmin';

export interface State {
  organizations: OrganizationDetails[];
  organizationTypes: IDropdown[];
  states: IDropdown[];
  isLoading: boolean;
  error: string | null;
}

export const initialState: State = {
  organizations: [],
  organizationTypes: [],
  states: [],
  isLoading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,
  
  // Load Organizations
  on(OrganizationAdminActions.loadOrganizations, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
    on(UserAdminActions.getOrganizationsSuccess, (state, action) => ({
      ...state,
      organizations: action.orgs,
    })),
  on(OrganizationAdminActions.loadOrganizationsSuccess, (state, { organizations }) => ({
    ...state,
    organizations,
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.loadOrganizationsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Load Organization Types
  on(OrganizationAdminActions.loadOrganizationTypes, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(OrganizationAdminActions.loadOrganizationTypesSuccess, (state, { organizationTypes }) => ({
    ...state,
    organizationTypes,
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.loadOrganizationTypesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Load States
  on(OrganizationAdminActions.loadStates, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(OrganizationAdminActions.loadStatesSuccess, (state, { states }) => ({
    ...state,
    states,
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.loadStatesFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Add Organization
  on(OrganizationAdminActions.addOrganization, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(OrganizationAdminActions.addOrganizationSuccess, (state, { organization }) => ({
    ...state,
    organizations: [...state.organizations, organization],
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.addOrganizationFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Update Organization
  on(OrganizationAdminActions.updateOrganization, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(OrganizationAdminActions.updateOrganizationSuccess, (state, { organization }) => ({
    ...state,
    organizations: state.organizations.map(org => 
      org.id === organization.id ? organization : org
    ),
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.updateOrganizationFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Delete Organization
  on(OrganizationAdminActions.deleteOrganization, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(OrganizationAdminActions.deleteOrganizationSuccess, (state, { organizationId }) => ({
    ...state,
    organizations: state.organizations.filter(org => org.id !== organizationId),
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.deleteOrganizationFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Set Test Organization Status
  on(OrganizationAdminActions.setTestOrganizationStatus, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(OrganizationAdminActions.setTestOrganizationStatusSuccess, (state, { organizationId, isTestOrganization }) => ({
    ...state,
    organizations: state.organizations.map(org =>
      org.id === organizationId ? { ...org, isTestOrganization } : org
    ),
    isLoading: false,
    error: null,
  })),
  on(OrganizationAdminActions.setTestOrganizationStatusFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  // Clear Errors
  on(OrganizationAdminActions.clearErrors, (state) => ({
    ...state,
    error: null,
  }))
);
